// extracted by mini-css-extract-plugin
module.exports = {"container":"profile-ProfileBanner__container--1uo64","image":"profile-ProfileBanner__image--bj7AY"};